export default __webpack_public_path__ + "static/6-95735eea0a8fd0e890f4cda48327951c.webp";